import Button from "@/components/Button";
import { smallerClosingCross } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { AppDispatch } from "@/redux/store";
import {
  anyFiltersSelectedSelector,
  clearAllFilters,
  selectedFiltersSelector,
  toggleFilter,
} from "@/redux/tactics/tacticsSlice";
import { useDispatch, useSelector } from "react-redux";

// Think whether this can be a generic component for all filters
interface TacticActiveFiltersRowProps {
  isInsideFiltersSidebar?: boolean;
}
const TacticActiveFiltersRow = ({
  isInsideFiltersSidebar = false,
}: TacticActiveFiltersRowProps) => {
  const anyFiltersSelected = useSelector(anyFiltersSelectedSelector);
  const selectedFilters = useSelector(selectedFiltersSelector);
  const dispatch = useDispatch<AppDispatch>();
  return (
    <article
      className={cn(
        anyFiltersSelected
          ? "flex justify-between items-start w-full px-2 desktop:px-0 gap-x-2"
          : "hidden",
        isInsideFiltersSidebar && "py-3 bg-gray-700",
      )}
    >
      <section className="flex desktop:flex-wrap gap-2 w-full overflow-x-auto overflow-y-hidden">
        {selectedFilters.map((filter) => (
          <Button
            key={filter.value}
            variant="primary"
            label={filter.label}
            onClick={() =>
              dispatch(
                toggleFilter({
                  category: filter.category,
                  value: filter.value,
                  label: filter.label,
                }),
              )
            }
            icon={<span className="fill-white">{smallerClosingCross}</span>}
          />
        ))}
      </section>
      {!isInsideFiltersSidebar && (
        <Button
          variant="tertiary"
          label="Clear Filters"
          onClick={() => dispatch(clearAllFilters())}
        />
      )}
    </article>
  );
};

export default TacticActiveFiltersRow;
